import React from "react";
import "../css/track-prog-sect.css";
import Sect5Img from "../assets/images/lp-sect5-img.png";

const TrackProgSect = () => {
  return (
    <section id="main-sect-5">
      <div>
        <article>
          <h2>
            Track and see your child/ ward progress as they study, from anywhere
          </h2>
          <img src={Sect5Img} id="sect5-illustration" alt="" />
          <p>
            Our philosophy is simple — hire a team of diverse, passionate people
            and foster a culture that empowers you to do you best work.
          </p>
        </article>
        <div>
          <h3>Put a smile on your childs face today, buy your first course</h3>
          <button>Buy course</button>
        </div>
      </div>
    </section>
  );
};

export default TrackProgSect;
